import HttpRequest from'../http/index.js';import {PRODUCT_STOCK_PATH,MARS_CORE_SERVER_PATH,MARS_WECHAT_MP_PATH}from'@monorepo/shared';/*
 * @Author: 彭鑫诚
 * @Date: 2024-08-12 21:17:01
 * @LastEditors: rxw
 * @LastEditTime: 2025-10-17 14:21:41
 * @Description: file content
 */
/** 获取列配置 */
const getCustomColumn = (params) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/staff_profile_resources/custom_column.json`,
        method: 'GET',
        params,
    });
};
/** 保存列配置 */
const updateCustomColumn = (data) => {
    return HttpRequest({
        url: `${PRODUCT_STOCK_PATH}/staff_profile_resources/custom_column.json`,
        method: 'POST',
        data,
    });
};
/** 主键读取订单详情-with订单所属列表类型 */
const getOrderJumpType = (id) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/orders/thin_with_order_list_type/${id}.json`,
        method: 'GET',
    });
};
const saveDomainCookieData = (data) => {
    return HttpRequest({
        url: `${MARS_WECHAT_MP_PATH}/westore_feature_web_localstorage.json`,
        method: 'POST',
        data,
    });
};
const getDomainCookieData = (merchant_id) => {
    return HttpRequest({
        url: `${MARS_WECHAT_MP_PATH}/westore_feature_web_localstorage.json`,
        method: 'GET',
        options: {
            merchant_id,
        },
    });
};
/** 查询年份设置 */
const getYearSetting = () => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_resources/query_year_setting.json`,
        method: 'GET',
    });
};export{getCustomColumn,getDomainCookieData,getOrderJumpType,getYearSetting,saveDomainCookieData,updateCustomColumn};//# sourceMappingURL=common.service.js.map
